import { chartingQueryKeys, invalidateChartingSavedSearches } from '@/features/charting-next/api/chartingCache';
import { createChartingSavedSearch, deleteChartingSavedSearch, fetchChartingSavedSearches, renameChartingSavedSearch } from '@/features/charting-next/api/chartingSavedSearchRepository';
import { useRemoteResource } from '@/features/charting-next/services/useRemoteResource';

export function useChartingSavedSearches({ sessionStore, capabilities, marketExplorer }) {
    const savedSearchesResource = useRemoteResource({
        key: () => chartingQueryKeys.savedSearches(sessionStore.uid),
        loader: fetchChartingSavedSearches,
        ttl: 30000,
        enabled: () => sessionStore.isAuthenticated && capabilities.value.canUseSavedSearches
    });

    const refreshSavedSearches = async () => {
        await invalidateChartingSavedSearches(sessionStore.uid);
    };

    const createSavedSearch = async ({ name = '', definition = null } = {}) => {
        await createChartingSavedSearch({
            name,
            definition: definition || marketExplorer.state.value?.appliedQuery
        });

        await refreshSavedSearches();
    };

    const renameSavedSearch = async ({ name = '', newName = '' } = {}) => {
        await renameChartingSavedSearch({
            name,
            newName
        });

        await refreshSavedSearches();
    };

    const removeSavedSearch = async (name) => {
        await deleteChartingSavedSearch(name);
        await refreshSavedSearches();
    };

    return {
        savedSearchesResource,
        createSavedSearch,
        renameSavedSearch,
        removeSavedSearch,
        refreshSavedSearches
    };
}
